"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatInbtTable = void 0;
const formatInbtTable = (bankDetails, customerDetails, amount, currency, translationsKeys) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const nextLine = true;
    return [
        { label: translationsKeys.amountText, value: `${currency.toUpperCase()} ${amount}` },
        { label: translationsKeys.senderRefText, value: `${customerDetails.tradingAccount} ${customerDetails.accountIdentificationCode}`, nextLine },
        {
            label: ((_a = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _a === void 0 ? void 0 : _a.beneficiaryName) ? translationsKeys.beneficiaryNameText : '',
            value: (_b = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _b === void 0 ? void 0 : _b.beneficiaryName
        },
        {
            label: ((_c = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _c === void 0 ? void 0 : _c.beneficiaryAddress) ? translationsKeys.beneficiaryAddressText : '',
            value: (_d = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _d === void 0 ? void 0 : _d.beneficiaryAddress
        },
        {
            label: (bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.accountNumber) ? translationsKeys.beneficiaryAccountNoText : '',
            value: bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.accountNumber
        },
        {
            label: ((_e = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _e === void 0 ? void 0 : _e.iban) ? translationsKeys.ibanText : '',
            value: (_f = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _f === void 0 ? void 0 : _f.iban,
            nextLine
        },
        // Beneficiary Bank
        {
            label: (bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankName) ? translationsKeys.beneficiaryBankText : '',
            value: bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankName
        },
        {
            label: ((_g = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _g === void 0 ? void 0 : _g.bankAddress) ? translationsKeys.beneficiaryBankAddressText : '',
            value: (_h = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _h === void 0 ? void 0 : _h.bankAddress
        },
        {
            label: ((_j = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _j === void 0 ? void 0 : _j.swiftCode) ? translationsKeys.beneficiaryBankAddressSwift : '',
            value: (_k = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _k === void 0 ? void 0 : _k.swiftCode,
            nextLine
        },
        // correspondent bank
        {
            label: ((_l = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _l === void 0 ? void 0 : _l.correspondentBank) ? translationsKeys.correspondentBankNameText : '',
            value: (_m = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _m === void 0 ? void 0 : _m.correspondentBank
        },
        {
            label: ((_o = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _o === void 0 ? void 0 : _o.correspondentSwiftCode) ? translationsKeys.correspondentSwiftText : '',
            value: (_p = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _p === void 0 ? void 0 : _p.correspondentSwiftCode
        },
        {
            label: ((_q = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _q === void 0 ? void 0 : _q.correspondentAccountNumber) ? translationsKeys.correspondentAccountText : '',
            value: (_r = bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.parameters) === null || _r === void 0 ? void 0 : _r.correspondentAccountNumber
        },
    ];
};
exports.formatInbtTable = formatInbtTable;
